/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderReceiveAddressVo } from './OrderReceiveAddressVo';
import {
    OrderReceiveAddressVoFromJSON,
    OrderReceiveAddressVoFromJSONTyped,
    OrderReceiveAddressVoToJSON,
    OrderReceiveAddressVoToJSONTyped,
} from './OrderReceiveAddressVo';
import type { Item1 } from './Item1';
import {
    Item1FromJSON,
    Item1FromJSONTyped,
    Item1ToJSON,
    Item1ToJSONTyped,
} from './Item1';

/**
 * 
 * @export
 * @interface KoreaReturnApplicationReqVo
 */
export interface KoreaReturnApplicationReqVo {
    /**
     * 本次申请UUID，重试必须沿用原值
     * @type {string}
     * @memberof KoreaReturnApplicationReqVo
     */
    requestId?: string;
    /**
     * 返送处理方式，沿用RocketReturnProcessMethodEnum
     * @type {number}
     * @memberof KoreaReturnApplicationReqVo
     */
    processMethod?: number;
    /**
     * 
     * @type {OrderReceiveAddressVo}
     * @memberof KoreaReturnApplicationReqVo
     */
    receiveAddress?: OrderReceiveAddressVo;
    /**
     * 返送商品列表，合包只提交父商品
     * @type {Array<Item1>}
     * @memberof KoreaReturnApplicationReqVo
     */
    items?: Array<Item1>;
}

/**
 * Check if a given object implements the KoreaReturnApplicationReqVo interface.
 */
export function instanceOfKoreaReturnApplicationReqVo(value: object): value is KoreaReturnApplicationReqVo {
    return true;
}

export function KoreaReturnApplicationReqVoFromJSON(json: any): KoreaReturnApplicationReqVo {
    return KoreaReturnApplicationReqVoFromJSONTyped(json, false);
}

export function KoreaReturnApplicationReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaReturnApplicationReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
        'processMethod': json['processMethod'] == null ? undefined : json['processMethod'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : OrderReceiveAddressVoFromJSON(json['receiveAddress']),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(Item1FromJSON)),
    };
}

export function KoreaReturnApplicationReqVoToJSON(json: any): KoreaReturnApplicationReqVo {
    return KoreaReturnApplicationReqVoToJSONTyped(json, false);
}

export function KoreaReturnApplicationReqVoToJSONTyped(value?: KoreaReturnApplicationReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
        'processMethod': value['processMethod'],
        'receiveAddress': OrderReceiveAddressVoToJSON(value['receiveAddress']),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(Item1ToJSON)),
    };
}

